import React from "react";
import { MessageSquare } from "lucide-react";

export default function CRMMessagesTab() {
  return (
    <div data-testid="crm-messages-tab" className="rounded-2xl border border-white/10 bg-black/25 p-8 text-center">
      <MessageSquare size={22} className="mx-auto text-cyan mb-2" />
      <h3 className="font-serif text-2xl text-white">Messages</h3>
      <div className="label-caps text-[10px] text-amber-300 tracking-widest mt-2">Phase 2</div>
      <p className="text-white/60 text-sm mt-3 max-w-lg mx-auto">
        Send SMS (Twilio) and email (Resend) directly from any customer profile. Threads save to the timeline. Opt-out is respected automatically.
      </p>
    </div>
  );
}
